import { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { Select, SelectProps } from '@shopify/polaris';

const SelectDropdown: FunctionComponent<SelectProps> = (props) => {
  const { label, labelInline, onChange, options, value } = props;
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectChange = useCallback(
    (value, id) => {
      setSelectedValue(value);
      onChange && onChange(value, id);
    },
    [onChange],
  );

  return (
    <Select
      label={label}
      labelInline={labelInline}
      options={options}
      onChange={handleSelectChange}
      value={selectedValue}
    />
  );
};

export default SelectDropdown;
